import { defineMessage } from 'react-intl';

/** Prefix before platform icons on a generated edit that already has publications. */
export const editCardPublishedOnMessage = defineMessage({
  id: 'videoEditions.editCard.publishedOn',
  defaultMessage: 'Publicado en',
});
